const API_URL = process.env.REACT_APP_BACKEND_URL;
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function getPushSupport() {
  if (!('serviceWorker' in navigator)) return { supported: false, reason: 'Service Workers are not supported in this browser.' };
  if (!('PushManager' in window)) return { supported: false, reason: 'Push notifications are not supported in this browser.' };
  if (!('Notification' in window)) return { supported: false, reason: 'Notifications API is not available.' };
  return { supported: true, reason: null };
}

export function getPermissionStatus() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'default', 'granted', 'denied'
}

export async function subscribePush(token) {
  const support = getPushSupport();
  if (!support.supported) return { ok: false, error: support.reason };

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'denied') {
      return { ok: false, error: 'blocked' };
    }
    if (permission !== 'granted') {
      return { ok: false, error: 'dismissed' };
    }

    const reg = await navigator.serviceWorker.register('/sw-push.js', { scope: '/' });
    await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
    const subJson = sub.toJSON();
    await fetch(`${API_URL}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ endpoint: subJson.endpoint, keys: subJson.keys }),
    });
    return { ok: true };
  } catch (e) {
    console.error('Push subscribe failed:', e);
    return { ok: false, error: e.message || 'Unknown error' };
  }
}

export async function unsubscribePush(token) {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (reg) {
      const sub = await reg.pushManager.getSubscription();
      if (sub) await sub.unsubscribe();
    }
    await fetch(`${API_URL}/api/push/unsubscribe`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    return true;
  } catch (e) {
    console.error('Push unsubscribe failed:', e);
    return false;
  }
}

export async function isPushSubscribed() {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}
